import { HttpErrorResponse } from '@angular/common/http';
import { AfterContentInit, AfterViewInit, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit, AfterContentInit {

  public resetPasswordForm: FormGroup;
  public otpForm: FormGroup;
  public isLoaded: boolean;
  public showOtpModal: boolean = false; // Flag to show OTP modal
  public isLoading : boolean = false;
  public isOtpLoading : boolean = false;

  constructor(
    private _formBuilder: FormBuilder,
    private _router: Router,
    private readonly authService: AuthService,
    private readonly toastService: ToastrService,
    private readonly localStorageService: LocalStorageService
  ) { }

  ngOnInit(): void {
    this.resetPasswordForm = this._formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });

    // Initialize OTP form
    this.otpForm = this._formBuilder.group({
      otp: ['', [Validators.required, Validators.pattern('[0-9]{6}')]], // Assume OTP is 6 digits
    });
  }

  ngAfterContentInit(): void {
    this.isLoaded = true;
  }

  /**
   * Navigates to a route given by the route parameter.
   * @param route - The route to navigate to.
   */
  public routeChange(route: string): void {
    this._router.navigateByUrl(route);
  }

  /**
   * Send a request to server to reset password for the given email.
   * Stores the email in local storage and shows OTP modal on success.
   * @returns {void}
   */
  forgotPassword() {
    this.isOtpLoading = true;
    this.localStorageService.set('email', this.resetPasswordForm.value.email);
    this.authService.forgotPassword(this.resetPasswordForm.value.email).subscribe({
      next: (res: any) => {
        this.isOtpLoading = false;
        this.toastService.success(res.message);
        this.showOtpModal = true; // Show OTP modal on success
      },
      error: (err) => {
        this.isOtpLoading = false;        
        this.toastService.error(err.error.message);
      }
    });
  }

  /**
   * Verify the OTP entered by the user with the server.
   * Stores the OTP in local storage and navigates to the
   * confirm password page on success.
   * @returns {void}
   */
  submitOtp() {  
    this.isLoaded = true;
    this.localStorageService.set('otp', this.otpForm.value.otp);
    this.authService.verifyOtp(Number(this.otpForm.value.otp),this.resetPasswordForm.value.email).subscribe({
      next: (res: any) => {
          this.isLoaded = false;
          this.toastService.success(res.message);
          this.routeChange('/auth/confirm-password');   
      },
      error: (err:HttpErrorResponse) => {
        this.isLoaded = false;
        this.toastService.error(err.error.message);
      }
    });
  }

  
}
